import React from 'react'
import { compose } from 'recompose'
import withDailyTimeBoundary from '../../components/ReservationTable/withDailyTimeBoundary'
import withReservationCount from '../../components/ReservationTable/withReservationCount'
import BookingSummaryTableContainer from './BookingSummaryTableContainer'
import Badge from '../../components/Badge'
import BackButton from '../../components/BackButton'
import DailyTimeBoundaryLabel from '../../components/DailyTimeBoundaryLabel'

class BookingSummaryPanelContainer extends React.Component {
  render() {
    const { totalCount, warningCount, dailyTimeBoundary } = this.props
    return (
      <div className="w-full">
        <div className="mb-6">
          <div className="flex items-center gap-4 mb-4">
            <BackButton onClick={this.props.onBack}>Back</BackButton>
            <h2 className="text-2xl font-semibold text-gray-900">
              Booking Summary
            </h2>
            <DailyTimeBoundaryLabel dailyTimeBoundary={dailyTimeBoundary} />
          </div>
          <div className="border-t border-gray-200"></div>
        </div>

        <div className="mb-4 flex items-center gap-3">
          <Badge label="Total" data={totalCount} dataStyle="success" />
          <Badge label="Warning" data={warningCount} dataStyle="danger" />
        </div>

        <BookingSummaryTableContainer />
      </div>
    )
  }
}

const query = {
  createByKiosk: false,
  daily: true,
}

const enhance = compose(withDailyTimeBoundary, withReservationCount(query))

export default enhance(BookingSummaryPanelContainer)
